export function openSpaces(locale) {
  const isFrench = locale && locale.indexOf('fr') >= 0;
  window.open(`${__SPACESURL__}${isFrench ? '/fr' : ''}`, '_parent');
}
